import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Alert, Spinner, Badge,Modal } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "../styles/AdSubmissionPayment.css";
const AdSubmissionPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [paymentData, setPaymentData] = useState(null);
  const [submissionData, setSubmissionData] = useState(null);
  const [packageDetails, setPackageDetails] = useState(null);
 const [showSuccessModal, setShowSuccessModal] = useState(false);
  useEffect(() => {
    if (location.state?.submissionData) {
      console.log("Submission data received:", location.state.submissionData);
      setSubmissionData(location.state.submissionData);
      fetchPackageDetails();
    } else {
      console.log("No submission data found, redirecting to form");
      navigate('/ad-submission');
    }
  }, [location.state, navigate]);
 
  const fetchPackageDetails = async () => {
    if (!location.state?.submissionData?.advertisement_package) {
      console.log("No advertisement package ID found in submission data");
      return;
    }
 
    console.log("Fetching package details for ID:", location.state.submissionData.advertisement_package);
 
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASEURL}/getallPricingTierswithoutauth`
      );
     
      console.log("Package API response:", response.data);
     
      if (response.data.success) {
        // Handle both string ID and object cases
        let selectedPackage;
       
        if (typeof location.state.submissionData.advertisement_package === 'string') {
          // If it's a string ID, find the package in the API response
          const packageId = location.state.submissionData.advertisement_package;
          console.log("Looking for package with ID:", packageId);
          selectedPackage = response.data.data.find(pkg => pkg._id === packageId);
        } else if (location.state.submissionData.advertisement_package._id) {
          // If it's an object with _id, use the object directly or find it in the response
          const packageId = location.state.submissionData.advertisement_package._id;
          console.log("Looking for package with ID:", packageId);
          selectedPackage = response.data.data.find(pkg => pkg._id === packageId);
         
          // If not found in API response, use the object directly
          if (!selectedPackage) {
            console.log("Package not found in API response, using provided object");
            selectedPackage = location.state.submissionData.advertisement_package;
          }
        } else {
          console.error("Invalid package data structure:", location.state.submissionData.advertisement_package);
          setError("Invalid package data. Please try again.");
          return;
        }
 
        console.log("Selected package found:", selectedPackage);
        setPackageDetails(selectedPackage);
       
        // Create payment order after package details are fetched
        if (selectedPackage) {
          createPaymentOrder(location.state.submissionData);
        } else {
          console.error("Package not found");
          setError("Selected package not found. Please try again.");
        }
      }
    } catch (error) {
      console.error("Error fetching package details:", error);
      setError("Failed to load package details. Please try again.");
    }
  };
 
  const createPaymentOrder = async (submissionDataParam = null) => {
    const dataToUse = submissionDataParam || submissionData;
    if (!dataToUse?._id) {
      console.error("No submission ID found");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/create-adsubmission-payment-order/${dataToUse._id}`
      );
 
      if (response.data.success) {
        setPaymentData(response.data.data);
      } else {
        setError(response.data.message || "Failed to create payment order");
      }
    } catch (error) {
      console.error("Error creating payment order:", error);
      setError(error.response?.data?.message || "Failed to create payment order");
    } finally {
      setLoading(false);
    }
  };
 
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };
 
  const handlePayment = async () => {
    if (!paymentData) return;
 
    setLoading(true);
    setError("");
 
    try {
      const res = await loadRazorpayScript();
      if (!res) {
        setError("Razorpay SDK failed to load. Please check your internet connection.");
        return;
      }
 
      const options = {
        key: paymentData.key_id,
        amount: paymentData.amount,
        currency: paymentData.currency,
        name: "AIOTA Advertisement Submission",
        description: `Payment for ${submissionData?.institution_name || 'Advertisement Submission'}`,
        order_id: paymentData.order_id,
     handler: async function (response) {
  try {
    const verifyResponse = await axios.post(
      `${process.env.REACT_APP_BASEURL}/verify-adsubmission-payment`,
      {
        razorpay_order_id: response.razorpay_order_id,
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_signature: response.razorpay_signature,
        submission_id: submissionData._id,
      }
    );

    if (verifyResponse.data.success) {
      setShowSuccessModal(true);
    } else {
      setError("Payment verification failed. Please contact support.");
    }
  } catch (error) {
    console.error("Payment verification error:", error);
    setError("Payment verification failed. Please contact support.");
  }
},
        prefill: {
          name: submissionData?.contact_person_name || "",
          email: submissionData?.contact_mail_id || "",
          contact: submissionData?.contact_number || "",
        },
        notes: {
          submission_id: submissionData?._id,
          institution_name: submissionData?.institution_name,
        },
        theme: {
          color: "#1a73e8",
        },
        modal: {
          ondismiss: function () {
            setLoading(false);
          },
        },
      };
 
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (error) {
      console.error("Payment error:", error);
      setError("Payment failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };
 
  if (!submissionData) {
    return (
      <div className="ad-submission-payment-loading">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p>Loading payment details...</p>
      </div>
    );
  }
 
  return (
    <>
    {/* Success Modal */}
<Modal 
  show={showSuccessModal} 
  onHide={() => {
    setShowSuccessModal(false);
    navigate('/');
  }}
  centered
  backdrop="static"
  keyboard={false}
>
  <Modal.Header style={{ border: 'none', paddingBottom: 0 }}>
    <Modal.Title className="w-100 text-center">
      <div style={{ color: '#28a745', fontSize: '48px', marginBottom: '10px' }}>
        <i className="fas fa-check-circle"></i>
      </div>
    </Modal.Title>
  </Modal.Header>
  <Modal.Body className="text-center px-4">
    <h4 className="mb-3" style={{ color: '#333', fontWeight: '600' }}>
      Success!
    </h4>
    <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6' }}>
      Your advertisement added successfully with payment. Further details will be updated through email.
    </p>
  </Modal.Body>
  <Modal.Footer style={{ border: 'none', justifyContent: 'center', paddingTop: 0 }}>
    <Button 
      variant="primary" 
      onClick={() => {
        setShowSuccessModal(false);
        navigate('/');
      }}
      style={{ minWidth: '120px', padding: '10px 30px' }}
    >
      OK
    </Button>
  </Modal.Footer>
</Modal>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
          </div>
        </div>
      </section>
 
      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container ad-submission-payment-content-container">
          <section className="ad-submission-payment-section">
            <Container className="container-ad-submission-payment">
              <h2 className="text-center ad-submission-payment-heading mb-4">
                Complete Your Payment
              </h2>
              <p className="text-center ad-submission-payment-subtitle mb-5">
                Secure payment for your advertisement submission
              </p>
 
              {error && (
                <Alert variant="danger" className="ad-submission-payment-alert">
                  {error}
                </Alert>
              )}
 
              <Row className="justify-content-center">
                <Col md={10} lg={8} xl={7}>
                  <Card className="ad-submission-payment-card">
                    <Card.Body className="">
                      <div className="text-center mb-4">
                        <div className="ad-submission-payment-icon mb-3">
                          <i className="fas fa-credit-card" style={{ fontSize: '48px', color: '#1a73e8' }}></i>
                        </div>
                        <h4 className="ad-submission-payment-card-title">
                          Advertisement Submission Payment
                        </h4>
                      </div>
 
                      <div className="ad-submission-payment-details">
                        <div className="ad-submission-payment-detail-row">
                          <span className="ad-submission-payment-label">Institution:</span>
                          <span className="ad-submission-payment-value">
                            {submissionData.institution_name}
                          </span>
                        </div>
                       
                        <div className="ad-submission-payment-detail-row">
                          <span className="ad-submission-payment-label">Contact Person:</span>
                          <span className="ad-submission-payment-value">
                            {submissionData.contact_person_name}
                          </span>
                        </div>
                       
                        <div className="ad-submission-payment-detail-row">
                          <span className="ad-submission-payment-label">Email:</span>
                          <span className="ad-submission-payment-value">
                            {submissionData.contact_mail_id}
                          </span>
                        </div>
 
                        {/* Package Details Section */}
                        <hr className="ad-submission-payment-divider" />
                        <div className="ad-submission-payment-package-section">
                          <h6 className="ad-submission-payment-package-title">
                            <i className="fas fa-box me-2"></i>
                            Selected Package
                          </h6>
                          <div className="ad-submission-payment-package-details">
                            {packageDetails ? (
                              <>
                                <div className="ad-submission-payment-detail-row">
                                  <span className="ad-submission-payment-label">Package Name:</span>
                                  <span className="ad-submission-payment-value">
                                    <Badge bg="primary">{packageDetails.name}</Badge>
                                  </span>
                                </div>
                                <div className="ad-submission-payment-detail-row">
                                  <span className="ad-submission-payment-label">Duration:</span>
                                  <span className="ad-submission-payment-value">
                                    {packageDetails.duration_years} year{packageDetails.duration_years > 1 ? 's' : ''}
                                  </span>
                                </div>
                                <div className="ad-submission-payment-detail-row">
                                  <span className="ad-submission-payment-label">Price:</span>
                                  <span className="ad-submission-payment-value">
                                    ₹{packageDetails.base_price}
                                  </span>
                                </div>
                                {packageDetails.description && (
                                  <div className="ad-submission-payment-detail-row">
                                    <span className="ad-submission-payment-label">Description:</span>
                                    <span className="ad-submission-payment-value">
                                      {packageDetails.description}
                                    </span>
                                  </div>
                                )}
                                {packageDetails.max_images && (
                                  <div className="ad-submission-payment-detail-row">
                                    <span className="ad-submission-payment-label">Max Images:</span>
                                    <span className="ad-submission-payment-value">
                                      {packageDetails.max_images}
                                    </span>
                                  </div>
                                )}
                                {packageDetails.max_characters && (
                                  <div className="ad-submission-payment-detail-row">
                                    <span className="ad-submission-payment-label">Max Characters:</span>
                                    <span className="ad-submission-payment-value">
                                      {packageDetails.max_characters}
                                    </span>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="text-center text-muted">
                                <i className="fas fa-spinner fa-spin me-2"></i>
                                Loading package details...
                              </div>
                            )}
                          </div>
                        </div>
 
                        {paymentData && (
                          <>
                            <hr className="ad-submission-payment-divider" />
               
                           
                            <div className="ad-submission-payment-detail-row ad-submission-payment-amount">
                              <span className="ad-submission-payment-label">Amount:</span>
                              <span className="ad-submission-payment-value">
                                ₹{paymentData.amount_rupees?.toFixed(2) || (paymentData.amount / 100).toFixed(2)}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
 
                      <div className="text-center mt-4">
                        <Button
                          variant="primary"
                          size="lg"
                          className="button-ad-submission-payment"
                          onClick={handlePayment}
                          disabled={loading || !paymentData}
                        >
                          {loading ? (
                            <>
<Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        className="me-2"
        style={{
          width: "14px",
          height: "14px",
          borderWidth: "2px",
        }}
      />                              Processing...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-credit-card me-2"></i>
                              Pay Now
                            </>
                          )}
                        </Button>
                      </div>
 
                      {/* Refund Policy Section */}
                      <div className="ad-submission-payment-refund-policy mt-4">
                        <Alert variant="warning" className="ad-submission-payment-refund-alert">
                          <div className="d-flex align-items-start">
                            <i className="fas fa-exclamation-triangle me-3 mt-1" style={{ color: '#856404' }}></i>
                            <div>
                              <h6 className="mb-2">
                                <strong>Payment Policy & Refund Information</strong>
                              </h6>
                              <ul className="mb-0 small">
                                <li><strong>Non-Refundable:</strong> Once payment is processed, it is non-refundable under normal circumstances.</li>
                                <li><strong>Technical Issues:</strong> If any network error or Razorpay technical error occurs during payment, the amount will be automatically refunded within 5-7 business days.</li>
                                <li><strong>Processing Time:</strong> Refunds for technical issues will be processed to your original payment method.</li>
                                <li><strong>Contact Support:</strong> For any payment-related queries, contact our support team.</li>
                              </ul>
                            </div>
                          </div>
                        </Alert>
                      </div>
 
                      <div className="ad-submission-payment-security mt-4">
                        <div className="text-center">
                          <i className="fas fa-shield-alt me-2" style={{ color: '#28a745' }}></i>
                          <small className="text-muted">
                            Your payment is secured by Razorpay
                          </small>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
 
              <div className="text-center mt-4">
                <Button
                  variant="outline-secondary"
                  onClick={() => navigate('/ad-submission')}
                  className="button-ad-submission-payment-back"
                >
                  <i className="fas fa-arrow-left me-2"></i>
                  Back to Form
                </Button>
              </div>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};
 
export default AdSubmissionPayment;
 
 